"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useAuth0 } from "@auth0/auth0-react";

import { useAuth0V2 } from "@stadium/services/auth0/utils";

import { LOGIN_CALLBACK_ROUTE } from "@stadium/services/auth0/constants";

/**
 * @deprecated Use CheckAuthHocV2 from services/auth0".
 */
export const CheckAuthHoc = (
  WrappedComponent,
  { apiHost, basePath = "", Loader, loginCallbackRoute, loginOptions = {} },
) => {
  function WrappingComponent(props) {
    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
    const asPath = usePathname();
    const authenticated = !isLoading && isAuthenticated;
    useEffect(() => {
      if (isLoading) {
        return;
      }

      if (!isAuthenticated) {
        loginWithRedirect({
          redirectUri:
            window.location.origin + (loginCallbackRoute || basePath + LOGIN_CALLBACK_ROUTE),
          appState: { returnTo: asPath },
          apiHost,
          ...loginOptions,
        });
      }
    }, [isAuthenticated, isLoading, loginWithRedirect]);

    return authenticated ? <WrappedComponent {...props} /> : <Loader />;
  }

  return WrappingComponent;
};

export const CheckAuthHocV2 = (
  WrappedComponent,
  { apiHost, basePath = "", Loader, loginCallbackRoute = "", loginOptions = {}, returnTo },
) => {
  function WrappingComponent(props) {
    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0V2();
    const asPath = usePathname();
    const authenticated = !isLoading && isAuthenticated;
    useEffect(() => {
      if (isLoading) {
        return;
      }
      const { signUp, ...restProps } = loginOptions;
      if (!isAuthenticated) {
        loginWithRedirect({
          redirectUri:
            window.location.origin + (loginCallbackRoute || basePath + LOGIN_CALLBACK_ROUTE),
          appState: { returnTo: returnTo?.() || asPath },
          apiHost,
          signUp: typeof signUp === "function" ? signUp() : signUp,
          ...restProps,
        });
      }
    }, [isAuthenticated, isLoading, loginWithRedirect]);
    return authenticated ? <WrappedComponent {...props} /> : <Loader />;
  }

  return WrappingComponent;
};
